import React, { useContext, useEffect, useRef } from "react";
import { observer } from "mobx-react";
import { autorun } from "mobx";
import { StoreContext } from "../StoreContext";
import { useSnackbar } from "notistack";
const Notifier = observer(() => {
    let displayed = useRef([]);
    const context = useContext(StoreContext);
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();
    const storeDisplayed = (id) => {
        let newDisplayed = displayed.current.slice(0);
        newDisplayed.push(id);
        displayed.current = newDisplayed;
    };
    useEffect(() => {
        autorun(() => {
            let notifications = context.rootStore.notificationStore.notifications;
            let notificationKeys = notifications.map((notification) => notification.key);
            let toRemove = displayed.current.slice(0).filter((key) => !notificationKeys.includes(key));
            toRemove.forEach((key) => {
                closeSnackbar(key);
                displayed.current = displayed.current.filter((id) => id != key);
            });
            notifications.forEach((notification) => {
                if (displayed.current.includes(notification.key)) {
                    return;
                }
                enqueueSnackbar(notification.message, { variant: notification.variant, key: notification.key });
                storeDisplayed(notification.key);
            });
        });
    }, []);
    return React.createElement(React.Fragment, null);
});
export default Notifier;
